import { LogoNotFound } from './LogoNotFound';
import { buildImage, Image } from '@axa-fr-axion/utils';

export const LogoComponent = (filename: string): Image => {
    try {
        return buildImage(require(`components/images/assets/logo/${ filename }.svg`), '');
    } catch {
        return LogoNotFound;
    }
};
